import { useState, useEffect } from "react";
import { MdWifiOff } from "react-icons/md";

export default function CheckOnline() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    function onlineHandler() {
      setIsOnline(true);
    }

    function offlineHandler() {
      setIsOnline(false);
    }

    window.addEventListener("online", onlineHandler);
    window.addEventListener("offline", offlineHandler);

    return () => {
      window.removeEventListener("online", onlineHandler);
      window.removeEventListener("offline", offlineHandler);
    };
  }, []);

  if (!isOnline)
    return (
      <div className="absolute z-50 top-0 px-4 py-1 bg-red-800 rounded-b-lg left-[46%]">
        <div className="flex items-center space-x-2">
          <MdWifiOff className="text-2xl" />
          <p className="text-sm font-semibold text-stone-200">
            No Internet Connection
          </p>
        </div>
      </div>
    );
}
